import { ethers } from 'ethers'

import { PublicKey } from '@solana/web3.js'

import { isSNSDomain } from '@src/chains/solana/utils/sns'
import { ChainId } from '@src/configs/chainInfo'
import { Address } from '@src/types/token'
import { isBitcoinAddress } from '@src/utils/address'
import { isPotentialENSName } from '@src/utils/ensUtils'

export const validateDestinationAddress = (address: Address | undefined, networkId: number): boolean => {
    if (!address) return false

    // Bitcoin address validation
    if (networkId === ChainId.Bitcoin) {
        return isBitcoinAddress(address)
    }

    // Solana address validation (including SNS domains)
    if (networkId === ChainId.Solana) {
        // Check if it's an SNS domain (.sol)
        if (isSNSDomain(address)) {
            return true // We consider SNS domains valid at this stage
        }
        // Otherwise validate as a regular Solana address
        return validateSolAddress(address)
    }

    // Tron address validation
    if (networkId === ChainId.Tron) {
        const tronAddressRegex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/
        return tronAddressRegex.test(address)
    }

    // EVM address validation - consider both valid EVM addresses and potential ENS names
    return validateEvmAddress(address) || isPotentialENSName(address)
}

// Validate EVM address
export function validateEvmAddress(address: string) {
    // Check if it's a valid EVM address
    return ethers.isAddress(address)
}

// Validate Solana address
export function validateSolAddress(address: string) {
    try {
        const pubkey = new PublicKey(address)
        const isSolana = PublicKey.isOnCurve(pubkey.toBuffer())
        return isSolana
    } catch (error) {
        return false
    }
}
